export default {
	name: 'intersection',

	inserted (el, binding) {
		const options = {
			rootMargin: '0px',
			threshold: 0.25
		}
		const callback = (entries, observer) => {
			if (entries[0].isIntersecting) {
				binding.value()
			}
		}
		const observer = new IntersectionObserver(callback, options)
		observer.observe(el)
	}
}
